import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import compose from 'recompose/compose';

export const FieldTitle = ({ resource, source, label, isRequired, }) => (
    <span>
        {typeof label !== 'undefined' ?
            label
            :
            (typeof source !== 'undefined' ?
                `resources.${resource}.fields.${source}`
                :
                ''
            )
        }
        {isRequired && ' *'}
    </span>
);

FieldTitle.propTypes = {
    isRequired: PropTypes.bool,
    resource: PropTypes.string,
    source: PropTypes.string,
    label: PropTypes.string,
};

const enhance = compose(pure);

export default enhance(FieldTitle);



// WEBPACK FOOTER //
// ./src/util/FieldTitle.js